import { TVerifyLoginRequest, TVerifyLoginResponse } from "@/features/auth/types/verify-login";
import { TApiRes } from "@/types/api";
import { clientApi } from "@/utils/api";
import { setToken } from "@/utils/token";
import Cookies from "js-cookie";

export const verifyLoginApi = async (payload: TVerifyLoginRequest): Promise<TVerifyLoginResponse> => {
  const {
    data: { data },
  } = await clientApi.post<TApiRes<TVerifyLoginResponse>>("/verify-login", payload);

  setToken(data.accessToken, data.refreshToken);
  Cookies.set("admin-email", data.email);
  return data;
};
